import { SvgIcon } from '@mui/material';
import React from 'react';

export default function RightCurveIcon({ ...props }) {
  return (
    <SvgIcon
      fill="none"
      height="17"
      viewBox="0 0 35 17"
      width="35"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clip-rule="evenodd"
        d="M34.4956 16.5724C33.375 16.5737 32.2906 16.5766 31.2413 16.5795C8.98098 16.6402 2.50126 16.6578 0.748047 0.00823617V16.9995H34.4956V16.5724Z"
        fill="black"
        fill-opacity="0.4"
        fill-rule="evenodd"
      />
    </SvgIcon>
  );
}
